import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSurveyActivationTimeAction = createAsyncThunk(
    'get-survey-time',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-survey-active-time`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSurveyActivationTimeSlice = createSlice({
    name: 'get-survey-time',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSurveyActivationTimeAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getSurveyActivationTimeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSurveyActivationTimeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSurveyActivationTimeReducer = getSurveyActivationTimeSlice.reducer